import { render, staticRenderFns } from "./RecordForm.vue?vue&type=template&id=9409ea9c&scoped=true"
import script from "./RecordForm.vue?vue&type=script&lang=js"
export * from "./RecordForm.vue?vue&type=script&lang=js"
import style0 from "./RecordForm.vue?vue&type=style&index=0&id=9409ea9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9409ea9c",
  null
  
)

export default component.exports